import { DiscountPercentInput } from "../DiscountFormControl/DiscountPercentInput";
import { DiscountTotalInput } from "../DiscountFormControl/DiscountTotalInput";
import { useProductsByIds } from "../../../services/productsService";
import { calculateTotalAgreementPrice } from "../../../page/AgreementsPage/AgreementConfigurationDialog/utils"; 
import {Grid} from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const BrokerInputForm = (props) => {
    const { t } = useTranslation();
    const { fields, productIds, productDiscounts , readonly = false,} = props;
    const { data: products, isLoading: isProductsLoading } = useProductsByIds(productIds);
    const agreementTotalPrice = useMemo(()=>{
        if (!productIds || !productDiscounts || isProductsLoading) {
            return 0
        }
        return calculateTotalAgreementPrice(products, productDiscounts).totalListedGross
    },[productIds, productDiscounts])
    
    const discountInput = () => (
        <DiscountPercentInput
            fieldName={fields.agreementBrokerPercentage}
            label={`${t("agreements.details.agreementBrokerPercentage")} %`}
            fullWidth
            range={{min: 0, max: 100}}
            productPrice={agreementTotalPrice}
            readonly={readonly}
            formatPercentAsDecimal={true}
            step={0.01}
        />
    );

    const totalInput = () => (
        <DiscountTotalInput
            fieldName={fields.agreementBrokerPercentage}
            label={`${t("agreements.details.agreementBrokerAmount")} zł`}
            fullWidth
            range={{min: 0, max: agreementTotalPrice}}
            productPrice={agreementTotalPrice}
            readonly={readonly}
            step={0.01}
        />
    );


    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="center" columnSpacing={3}>
            <Grid item xs={6}>{discountInput()}</Grid>
            <Grid item xs={6}>{totalInput()}</Grid>
        </Grid>
    );
};
